/**
 * border-canada slug — create-form input schema and Mantine form helpers.
 * @see docs/OPT_IN_ORDER_DOCUMENTS.md
 */
import { z } from "zod";

import {
  type BorderCanadianDocumentInput,
  BorderCanadianDocumentInputSchema,
  BorderCanadianLineItemInputSchema,
} from "~/shared/documents/schemas/border-canada-input.schema";

export {
  type BorderCanadianDocumentInput,
  BorderCanadianDocumentInputSchema,
  BorderCanadianLineItemInputSchema,
} from "~/shared/documents/schemas/border-canada-input.schema";

const BorderCanadianDocumentFieldsSchema = BorderCanadianDocumentInputSchema.omit({ orderId: true }).extend({
  lineItems: z.array(BorderCanadianLineItemInputSchema),
});

/** Mantine shell before prefill loads; lineItems stay empty until server prefill returns. */
export const borderCanadianDocumentFormInitialValues = (): Omit<BorderCanadianDocumentInput, "orderId"> =>
  BorderCanadianDocumentFieldsSchema.parse({ lineItems: [] });
